import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import en from './locales/en/common.json';
import es from './locales/es/common.json'; // Add other languages as needed
import fr from './locales/fr/common.json'; // Add other languages as needed
import gu from './locales/gu/common.json'; // Add other languages as needed
import hi from './locales/hi/common.json'; // Add other languages as needed
import ma from './locales/ma/common.json'; // Add other languages as needed
import pj from './locales/pj/common.json'; // Add other languages as needed
import ta from './locales/ta/common.json'; // Add other languages as needed

i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		compatibilityJSON: 'v3', // <--- add this line
		fallbackLng: 'en',
		lng: 'hi', // default language
		resources: {
			en: { translation: en },
			es: { translation: es },
			hi: { translation: hi },
			pj: { translation: pj },

			gu: { translation: gu },
			ta: { translation: ta },
			ma: { translation: ma },
			fr: { translation: fr },
			// add other languages here
		},
		backend: {
			loadPath: './locales/{{lng}}/common.json',
		},
		saveMissing: true, // Saves any missing keys to your backend
		interpolation: {
			escapeValue: false, // React already safes from xss
		},
	});

export default i18n;
